import { render, staticRenderFns } from "./tabUsCustomsClearanceMaster.vue?vue&type=template&id=acd5e16e&scoped=true&"
import script from "./tabUsCustomsClearanceMaster.vue?vue&type=script&lang=js&"
export * from "./tabUsCustomsClearanceMaster.vue?vue&type=script&lang=js&"
import style0 from "./tabUsCustomsClearanceMaster.vue?vue&type=style&index=0&id=acd5e16e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd5e16e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acd5e16e')) {
      api.createRecord('acd5e16e', component.options)
    } else {
      api.reload('acd5e16e', component.options)
    }
    module.hot.accept("./tabUsCustomsClearanceMaster.vue?vue&type=template&id=acd5e16e&scoped=true&", function () {
      api.rerender('acd5e16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster.vue"
export default component.exports